<input
    class="shared-radio-button"
    type="radio"
    [id]="id()"
    [name]="name()"
    [value]="value()"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="onCheckedChange($event)"
/>